import React, { useState } from "react";
import Teamlisting from "../component/team/Teamlisting";
import LayoutSchedule from "../component/schedule/layoutSchedule";
import AdBanner from "../component/ads/AdBanner";

const Homepage: React.FC = () => {
  // const [playerId, setPlayerId] = useState("");
  // const [playerData, setPlayerData] = useState(null);
  // const [results, setResults] = useState(null);
  // const [selectedTeam, setSelectedTeam] = useState(null);
  // const [colorsTeam, setColorsTeam] = useState([]);
  // const handleTeamSelection = (team) => {
  //   setSelectedTeam(team); // Update the state with the selected team
  // };

  return (
    <div className="wrapper">
      <div className="main">
        <LayoutSchedule />
        <Teamlisting />
      </div>
    </div>
  );
};

export default Homepage;
